var m = require('mithril');
var loaders = require('../layout/components/loaders');
var auth = require('../auth/models/session');

var lastRoute = null;

function normalizeRoute(route) {
  return String(route || '').trim();
}

function isViewRoute(route) {
  var normalized = normalizeRoute(route);
  if (!normalized) return false;
  var path = normalized.split('?')[0];

  if (/^\/location\/[^/]+$/.test(path)) return true;
  if (/^\/equipment\/[^/]+\/[^/]+$/.test(path)) return true;
  if (/^\/dashboard\/[^/]+$/.test(path)) return true;

  return false;
}

function extractRouteRid(route) {
  var normalized = normalizeRoute(route);
  if (!normalized) return '';
  var value = normalized;
  var hashBangIndex = value.indexOf('#!');
  if (hashBangIndex !== -1) {
    value = value.slice(hashBangIndex + 2);
  } else {
    var hashIndex = value.indexOf('#');
    if (hashIndex !== -1) {
      value = value.slice(hashIndex + 1);
    }
  }
  value = value.replace(/^https?:\/\/[^/]+/, '');
  var path = value.split('?')[0];
  var segments = path.split('/').filter(Boolean);
  var ridPattern = /^\d+:\d+$/;
  for (var i = segments.length - 1; i >= 0; i -= 1) {
    if (ridPattern.test(segments[i])) {
      return segments[i];
    }
  }
  var match = path.match(/#?(\d+:\d+)/);
  return match ? match[1] : '';
}

function recordViewEvent(route) {
  var normalized = normalizeRoute(route);
  if (!normalized || !isViewRoute(normalized)) return Promise.resolve();
  if (normalized === lastRoute) return Promise.resolve();
  lastRoute = normalized;

  var routeRid = extractRouteRid(normalized);
  if (!routeRid) return Promise.resolve();

  return loaders.requestWithLoader({
    loader: 'background',
    method: 'POST',
    url: '/api/v1/viewevent',
    body: { 
      url: normalized,
      object: `#${routeRid}`,
      user: auth.user() && auth.user()['@rid'] ? auth.user()['@rid'] : null
    }
  }).catch(function (err) {
    console.error('Failed to record view event', err);
  });
}

function recordCurrentViewEvent() {
  return recordViewEvent(m.route.get());
}

module.exports = {
  recordViewEvent: recordViewEvent,
  recordCurrentViewEvent: recordCurrentViewEvent,
  isViewRoute: isViewRoute
};
